import { FC } from 'react';
import { Comment } from '../../interfaces/types';
import { Avatar, Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useUserContext } from '../../providers/userProvider';
import { useCustomThemeContext } from '../../providers/customThemeProvider';

dayjs.extend(relativeTime);

interface CommentListItemProps {
    comment: Comment;
}

const CommentListItem: FC<CommentListItemProps> = ({ comment }) => {
    const { theme } = useCustomThemeContext();
    const { userDetails, getUserById } = useUserContext();
    const commentedBy = getUserById(comment.createdBy);
    const isCurrentUser = commentedBy?.uid === userDetails?.uid;

    return (
        <Box sx={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', width: '100%' }}>
            <Box display="flex" justifyContent={isCurrentUser ? 'flex-end' : 'flex-start'} alignItems="center">
                <Avatar src={commentedBy?.profileImageUrl} sx={{ width: '20px', height: '20px', marginRight: 1 }} />
                <Typography color={theme.palette.primary.main}>{commentedBy?.username}</Typography>
            </Box>
            <Typography data-testid={isCurrentUser? 'commentByMe' : 'commentByOthers'} justifySelf={isCurrentUser? 'flex-end' : 'flex-start'}>{comment.content}</Typography>
        </Box>
    );
};

export default CommentListItem;